export interface DocumentListVisibilityInput {
  source: 'public' | 'fiscal';
  status?: string | null;
  archivedAt?: string | null;
}

/**
 * La lista principale contiene soltanto import attivi. Un cancel/replace marca
 * il DDT `archived_at` o la fattura `rejected`: lasciarli azionabili produce
 * retry "already cancelled" e confonde lo storico con la giacenza corrente.
 */
export function isActiveDocumentListRow(
  input: DocumentListVisibilityInput,
): boolean {
  return input.source === 'public'
    ? input.archivedAt == null
    : input.status !== 'rejected';
}
